import { render, staticRenderFns } from "./MantenteInformado.vue?vue&type=template&id=092fad10&scoped=true"
import script from "./MantenteInformado.vue?vue&type=script&lang=js"
export * from "./MantenteInformado.vue?vue&type=script&lang=js"
import style0 from "./MantenteInformado.vue?vue&type=style&index=0&id=092fad10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092fad10",
  null
  
)

export default component.exports